import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40008 40082"
    {...props}
  >
    <path
      d="M1373 26707v2667c0 5133 4192 9335 9315 9335h18632c5123 0 9315-4202 9315-9335v-2667m0-13334v-2667c0-5133-4192-9333-9315-9333H10688c-5123 0-9315 4200-9315 9333v2667"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 2745.27,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
